module.exports = __webpack_public_path__ + "static/media/fb.f52a51de.svg";